enum PlatformIntegrationFieldType {
  SECRET = "SECRET",
  TEXT = "TEXT",
  URL = "URL",
  MULTILINE = "MULTILINE",
  SELECT = "SELECT",
}

export default PlatformIntegrationFieldType;
